<template>
  <div class="PrintApply">
    <el-dialog
      :title="type === 1 ? '未套打证书申请' : '补打证书申请'"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose">

      *请勾选要套打的证书 &nbsp; &nbsp; 用户电话: <el-input v-model="filter.phone" size="small" placeholder="请输入用户电话" style="width: 150px"></el-input>
      <el-button type="primary" size="small" style="margin-left: 10px" @click="search">搜索</el-button>
      <el-button type="" size="small" @click="reset">重置</el-button>

      <el-table v-if="dialogVisible" ref="multipleTable" style="margin-top: 10px" border :data="list" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
        <el-table-column align="center" label="班级名称" prop="skuName" width=""></el-table-column>
        <el-table-column align="center" label="已绑定证书" :prop="type === 1 ? 'qualifiedNumber' : 'certificateNo'" width=""></el-table-column>
        <el-table-column align="center" label="所属项目" prop="projectName" width=""></el-table-column>
        <el-table-column align="center" label="考场名称" :prop="type === 1 ? 'title' : 'examTitle'" width=""></el-table-column>
        <el-table-column align="center" label="用户昵称" prop="name" width=""></el-table-column>
        <el-table-column align="center" label="用户电话" prop="phone" width=""></el-table-column>
        <el-table-column align="center" label="合格证套打状态" prop="" width="">
          <template slot-scope="scope">
            <span v-if="type === 1">{{ scope.row.qualifiedPrintNum && scope.row.qualifiedPrintNum > 0 ? '已套打' : '未套打' }}</span>
            <template v-else>
              <span v-if="scope.row.printState === 1">未套打</span>
              <span v-if="scope.row.printState === 2">补打</span>
              <span v-if="scope.row.printState === 3">已套打</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

      <el-form style="margin-top: 20px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
        <el-form-item v-if="type === 1" label="申请说明" prop="applyExplain">
          <el-input v-model="ruleForm.applyExplain" type="textarea" :rows="3" maxlength="500" size="small" placeholder="请输入申请说明"></el-input>
        </el-form-item>
        <el-form-item v-if="type === 2" label="补打原因" prop="repairPrintReason">
          <el-select v-model="ruleForm.repairPrintReason" placeholder="请选择补打原因">
            <el-option label="错误打印" value="1"></el-option>
            <el-option label="损坏证书" value="2"></el-option>
            <el-option label="丢失证书" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="type === 2" label="申请说明" prop="repairPrintExplain">
          <el-input v-model="ruleForm.repairPrintExplain" type="textarea" :rows="3" maxlength="500" size="small" placeholder="请输入申请说明"></el-input>
        </el-form-item>
        <el-form-item v-if="type === 2" label="" prop="">
          <Upfile accept=".JPG, .jpg, .png, .PNG, .jpeg, .JPEG" v-model="ruleForm.repairPrintImg" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submit">提交申请</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUnPrintList, getTDListPage, addApply } from "@/api/certificate/index";
import Upfile from '@/components/upload/file'
export default {
  name: 'PrintApply',
  components: { Upfile },
  data () {
    return {
      dialogVisible: false,
      type: 1,
      filter: {
        page: 1,
        limit: 10,
        phone: ''
      },
      list: [],
      total: 0,
      ruleForm: {
        item: [],
        applyExplain: '',
        repairPrintReason: '',
        repairPrintExplain: '',
        repairPrintImg: ''
      },
      rules: {
        applyExplain: [{ required: true, message: '请输入申请说明', trigger: 'blur' }],
        repairPrintReason: [{ required: true, message: '请选择补打原因', trigger: 'change' }],
        repairPrintExplain: [{ required: true, message: '请输入申请说明', trigger: 'blur' }]
      },
      selectList: []
    }
  },
  methods: {
    init(type) {
      this.type = type
      this.getList()
      this.dialogVisible = true
    },
    async getList() {
      let res
      if (this.type === 1) {
        res = await getUnPrintList({...this.filter, printState: 3})
      } else {
        res = await getTDListPage(this.filter)
      }
      this.list = res.data.records
      this.total = +res.data.total
    },
    handleSelectionChange(v) {
      this.selectList[this.filter.page] = v
      let arr = []
      this.selectList.forEach(item => {
        item && item.forEach(col => {
          arr.push(col)
        })
      })
      this.ruleForm.item = arr
    },
    submit() {
      if (this.ruleForm.item.length === 0) {
        return this.$message.error('请选择数据')
      }
      this.$refs['ruleForm'].validate(async(valid) => {
        if (valid) {
          const sendData = {...this.ruleForm, applyType: this.type}
          sendData.item = JSON.stringify(sendData.item)
          const res = await addApply(sendData)
          this.handleClose()
          this.$message.success('申请成功')
        }
      })
    },
    selectable(v) {
      if ((this.type === 2 && this.ruleForm.item.length >= 1)) {
        if (this.ruleForm.item.some(c => c.id === v.id)) {
          return true
        }
        return false
      } else {
        return true
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.selectList = []
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = ''
      })
      this.ruleForm.item = []
      this.$parent.search()
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.limit = v
      this.handleCurrentChange(1)
    },
    handleCurrentChange(v) {
      this.filter.page = v
      const arr = [...(this.selectList[v] || [])]
      this.getList()

      setTimeout(() => {
        arr.forEach(item => {
          const row = this.list.filter(v => v.id === item.id)
          this.$refs.multipleTable.toggleRowSelection(row[0]);
        })
      }, 100);
    }
  }
}
</script>

<style lang="scss" scoped>
.PrintApply {

}
</style>
